import React, { createContext, useContext, useMemo } from "react";
import { useEventHostAttention } from "./EventHostAttentionContext";

export const ParticipantRequestUnreadContext = createContext(null);

const clampInt = (v) => {
  const n = Number(v);
  if (!Number.isFinite(n)) return 0;
  return Math.max(0, Math.floor(n));
};

const EMPTY_CONTEXT = {
  totalUnread: 0,
  unreadEventsCount: 0,
  byEventId: {},
  eventMetaById: {},
  refetch: async () => {},
};

export const ParticipantRequestUnreadProvider = ({ children }) => {
  const { data: attentionData, refetch } = useEventHostAttention();
  const data = attentionData?.participant_requests;

  const value = useMemo(() => {
    const totalUnread = clampInt(data?.total_unread);
    const unreadEventsCount = clampInt(data?.unread_events_count);
    const byEventId = {};
    const eventMetaById = {};
    const eventsArr = Array.isArray(data?.events) ? data.events : [];

    eventsArr.forEach((item) => {
      const eventId = item?.event_id != null ? String(item.event_id) : null;
      if (!eventId) return;
      const unreadCount = clampInt(item?.unread_count ?? item?.pending_count);
      byEventId[eventId] = unreadCount;
      eventMetaById[eventId] = {
        eventId: Number(item?.event_id || 0) || null,
        eventName: String(item?.event_name || ""),
        unreadCount,
      };
    });

    return {
      totalUnread,
      unreadEventsCount,
      byEventId,
      eventMetaById,
      refetch,
    };
  }, [data, refetch]);

  return (
    <ParticipantRequestUnreadContext.Provider value={value}>
      {children}
    </ParticipantRequestUnreadContext.Provider>
  );
};

export const useParticipantRequestUnread = () => {
  const ctx = useContext(ParticipantRequestUnreadContext);
  return ctx || EMPTY_CONTEXT;
};
